module.exports = __webpack_public_path__ + "static/media/PA-Icon-T├╝r-neg.6eb5ca69.svg";